import { CaptureStatus, formatMoney, OrderDetails } from '@nemuru-eng/js-api-client';

import { OrderAction } from '../../../../../types/OrderAction';
import { OrderActionType } from '../../../../../types/OrderActionType';
import { OrderLineInAction } from '../../../../../types/OrderLineInAction';
import { getItemTooltip } from './getItemTooltip';

export const getCaptureActions = (orderDetails: OrderDetails): OrderAction[] => {
  const captureActions: OrderAction[] = [];
  const captures = orderDetails.captures;
  const currency = orderDetails.currency;

  if (!captures) return captureActions;

  captures
    .filter((capture) => capture.status === CaptureStatus.APPROVED && capture.notified === true)
    .sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1))
    .forEach((capture, index) => {
      captureActions.push({
        id: capture.id,
        type: OrderActionType.capture,
        status: capture.status,
        createdAt: capture.createdAt,
        updatedAt: capture.updatedAt,
        amount: { value: capture.amount, currency },
        orderLines: capture.itemIds.map((orderLineId) => {
          const item = orderDetails.order.items.find((item) => item.id === orderLineId);
          if (!item) return;
          return {
            id: item.id,
            name: item.article.name,
            amount: { value: item.totalPriceWithTax, currency },
            infoText: `${formatMoney({ value: item.article.unitPriceWithTax, currency: currency })} x ${item.units}`,
            tooltip: getItemTooltip(item),
          } as OrderLineInAction;
        }),
        number: index + 1,
      });
    });

  return captureActions;
};
